<template>
    <div class="home">
        <Nav/>
        <div class="banner-img">
            <img src="../assets/04.png"/>
        </div>
        <div class="main">
            <div class="main-t">关于我们</div>
            <div class="main-n">
                <div class="mt38 tab-active hv" data-type="1" @click="currentTargetEvent(1)">+ <span class="under-line"
                                                                                                  data-type="info">基本信息</span>
                </div>
                <div class="mt38 hv" data-type="2" @click="currentTargetEvent(2)">+ <span data-type="card">证件展示</span>
                </div>
                <div class="mt38 hv" data-type="3" @click="currentTargetEvent(3)">+ <span data-type="contact">联系我们</span>
                </div>
            </div>
            <div class="pro-info" v-show="currentType === 1">
                <div>
                    <h3>股东背景</h3>
                    <div class="mt25">
                        上海金蝶蝶金云计算有限公司是蝶金小贷的唯一股东，其隶属于金蝶国际软件集团有限公司。金蝶国际软件集团有限公司始创于1993年，是香港联交所主板上市公司，已为超过680万家企业和政府组织提供企业管理软件及云服务。
                    </div>
                </div>
                <div>
                    <h3>组织架构</h3>
                    <div class="mt25">蝶金小贷下设产品部、市场部、风控部、技术部和财务部，员工均有在银行、小额贷款公司等金融行业相关公司的工作履历，具有较为丰富的信贷行业从业经验。</div>
                    <img class="mt50 ml100" src="../assets/13123.png"/>
                </div>
                <div>
                    <h3>高管信息</h3>
                    <h5 class="mt25">王宏（执行董事/法定代表人）</h5>
                    <div>毕业于中南财经政法大学；历任金蝶实施顾问、品牌总监、董事会主席助理。第七、第八届深圳市青联委员，第五-九届中国管理模式杰出奖理事会秘书长。</div>
                    <h5 class="mt25">朱海勃（总经理）</h5>
                    <div>北京航空航天大学金融学硕士；原民生银行、中信银行总行小微金融产品专家，十年小微金融产品设计、风险管理及整体运营经验。</div>
                    <h5 class="mt25">李竹君（副总经理兼财务总监）</h5>
                    <div>广东外语外贸大学财务管理学士；12年金融业财务管理工作经验；先后就职于中国平安、中国信达、佳兆业集团等国内知名企业。</div>
                    <h5 class="mt25">刘春艳（技术负责人）</h5>
                    <div>金融系统设计专家；历任金蝶信科事业部系统规划师与金蝶信科科技经理；8年金融系统建设和项目管理经验，逾二十个金融系统的成功交付经验。</div>
                </div>
            </div>
            <div class="pro-info" v-show="currentType === 2" @click="showImgEvent()">
                <div>
                    <h3>监管部门相关批复</h3>
                    <div class="mt25 fl">
                        <div class="img-title">
                            <img src="../assets/728-1.png" data-url="../assets/orgin-4.png">
                            <img src="../assets/orgin-4.png" data-url="../assets/orgin-4.png" style="display: none">
                            <p>穗金融函【2016】728号</p>
                        </div>
                        <div class="img-title">
                            <img src="../assets/202-1.png" data-url="../assets/origin-1.png">
                            <img src="../assets/origin-1.png" style="display: none">
                            <p>越金融【2016】202号</p>
                        </div>
                    </div>
                </div>
                <div>
                    <h3>经营许可证</h3>
                    <div class="mt25 fl">
                        <div class="img-title">
                            <img src="../assets/53-1.png" data-url="../assets/origin-3.png">
                            <img src="../assets/origin-3.png" style="display: none">
                            <p>穗金融贷【2016】53号</p>
                        </div>
                        <div class="img-title">
                            <img src="../assets/256-1.png" data-url="../assets/origin-2.png">
                            <img src="../assets/origin-2.png" style="display: none">
                            <p>穗金融贷【2016】256号</p>
                        </div>
                    </div>
                </div>
                <div>
                    <h3>营业执照</h3>
                    <div class="mt25 fl">
                        <div class="img-title">
                            <img src="../assets/licenese.png">
                            <img src="../assets/licenese.png" style="display: none">
                            <p>穗金融函【2016】728号</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="pro-info" v-show="currentType === 3">
                <div>
                    <h3>公司地址</h3>
                    <div class="mt25">广州：广州市越秀区解放南路123号12层1204房<br/> 深圳：深圳市南山高新技术开发区科技南十二路2号</div>
                </div>
                <div>
                    <h3>联系电话</h3>
                    <div class="mt25">0755-86072588</div>
                </div>
            </div>
            <Foot/>
        </div>
    </div>
</template>

<script>
import Nav from './Nav';
import Foot from './Foot';

export default {
  name: 'Home',
  components: { Nav, Foot },
  data() {
    return { currentType: 1 };
  },
  props: {},
  mounted() {
    this.$nextTick(() => {
      document.getElementsByClassName('aboutUs-tab')[0].style.color = '#F29700';
    });
  },
  methods: {
    effectiveLoanEvent() {
      this.$router.push({ path: `/permission/index?${+new Date()}` });
    },
    showImgEvent() {
      if (event.target.nodeName == 'IMG' && event.target.nextElementSibling.nodeName == 'IMG') {
        window.open(event.target.nextElementSibling.src);
      }
    },
    currentTargetEvent(currentType) {
      const elm = event.currentTarget.parentNode.children;
      if (elm) {
        for (let i = 0, pl = elm.length; i < pl; i++) {
          if (elm[i] !== elm && elm[i].classList.contains('tab-active')) {
            elm[i].classList.remove('tab-active');
            elm[i].children[0].classList.remove('under-line');
          }
        }
      }
      this.currentType = currentType;
      event.currentTarget.classList.add('tab-active');
      event.currentTarget.children && event.currentTarget.children[0].classList.add('under-line');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    @media screen and (min-width: 800px) {
        .home {
            .banner-img {
                img {
                    width: 100%;
                }
            }
            .main {
                height: 729px;
                padding-bottom: 100px;
                position: relative;
                //padding-left: 20px;
                //padding-right: 20px;
                .main-t {
                    margin-left: 16.60%;
                    width: 18px;
                    height: 252px;
                    font-size: 12px;
                    font-family: PingFangSC-Semibold;
                    font-weight: 500;
                    color: rgba(0, 0, 0, 0.1);
                    line-height: 62px;
                    position: absolute;
                }
                .main-n {
                    position: absolute;
                    height: 27px;
                    font-size: 20px;
                    font-family: PingFangSC-Semibold;
                    font-weight: 600;
                    color: rgba(196, 187, 179, 1);
                    line-height: 28px;
                    margin-left: 20.6%;
                }
                .mt38 {
                    margin-top: 38px;
                }
                .tab-active {
                    color: #000000;
                    padding-left: 48px;

                }
                .hv:hover{
                    cursor: pointer;
                }
                .under-line {
                    padding-bottom: 10px;
                    border-bottom: 2px solid rgba(242, 151, 0, 0.6);
                }
                .pro-info {
                    position: relative;
                    margin-left: 33.55%;
                    margin-right: 10%;
                    .black-bl {
                        position: absolute;
                        top: -17px;
                        color: rgba(51, 47, 43, 1);
                        font-weight: 600;
                        font-size: 26px;
                    }
                    .img-title {
                        text-align: center;
                    }
                    .fl {
                        display: flex;
                    }
                    div {
                        font-size: 13px;
                        font-family: PingFangSC-Regular;
                        font-weight: 400;
                        color: rgba(142, 142, 142, 1);
                        line-height: 26px;
                    }
                    .mt25 {
                        margin-top: 25px;
                        img {
                            width: 229px;
                            height: 325px;
                        }
                    }
                    .mt50 {
                        margin-top: 50px;
                    }
                    .ml100 {
                        margin-left: 100px;
                    }
                    h3 {
                        padding-top: 70px;
                        font-size: 20px;
                        color: rgba(51, 47, 43, 1);
                    }
                    h5 {
                        color: #332F2B
                    }
                    .mt40 {
                        margin-top: 40px;
                    }
                    .ml60 {
                        margin-left: 3.125%;
                    }
                }
            }

        }
    }

    @media screen and (max-width: 800px) {
        .banner-img {
            img {
                width: 100%;
            }
        }
        .main {
            height: 729px;
            padding-bottom: 100px;
            position: relative;
            .main-t {
                margin-left: 2%;
                width: 18px;
                height: 252px;
                font-size: 10px;
                font-family: PingFangSC-Semibold;
                font-weight: 500;
                color: rgba(0, 0, 0, 0.1);
                line-height: 62px;
                position: absolute;
            }
            .main-n {
                font-size: 14px;
                font-family: PingFangSC-Semibold;
                font-weight: 600;
                color: rgba(196, 187, 179, 1);
                line-height: 28px;
                margin-left: 5%;
            }
            .pro-info {
                margin: auto 22px;
            }
        }
        .ml25 {
            img {
                width: 200px;
            }
        }
    }

</style>
